// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_containers_pgmbusiness {
  overflow: hidden;
  height: 100vh;
}
.details_containers_pgmbusiness .businessContainers {
  width: 100%;
  display: flex;
  overflow: hidden;
  height: 100vh;
}
.details_containers_pgmbusiness .loader-location {
  position: absolute !important;
  top: 28% !important;
  left: 80% !important;
}
.details_containers_pgmbusiness .busines_partners_crossicons {
  position: absolute;
  z-index: 4;
  left: 7rem;
  top: 1rem;
}
.details_containers_pgmbusiness .cursor-pointer {
  cursor: pointer;
}
.details_containers_pgmbusiness .businessContainerleft {
  width: 22%;
}
.details_containers_pgmbusiness .businessConntainersright {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.details_containers_pgmbusiness .businessConntainersright::-webkit-scrollbar {
  width: 0px;
}
.details_containers_pgmbusiness .businessConntainersright::-webkit-scrollbar-thumb {
  background: transparent;
}
.details_containers_pgmbusiness .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.details_containers_pgmbusiness .header_border > img {
  margin: 0.9rem 1rem;
}
.details_containers_pgmbusiness .pgmlist_buttons {
  display: flex;
  width: 98%;
  margin: 1rem;
  gap: 1rem;
  border-bottom: 1px solid #c1c6d0;
}
.details_containers_pgmbusiness .Pgmlist_pending {
  width: 15%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0c3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #ffffff;
}
.details_containers_pgmbusiness .pgmlist_Approved {
  width: 15%;
  height: 40px;
  background: #e5f0ff;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7c87a1;
  border: none;
}
.details_containers_pgmbusiness .pgmlist_Add {
  width: 15%;
  height: 40px;
  background: #e5f0ff;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7c87a1;
  border: none;
}
.details_containers_pgmbusiness .Partner_para_four_span {
  width: 29px;
  height: 29px;
  background: #1445a4;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmbusiness .Partner_para_four_paragraphs {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #9ca8c0;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0rem;
}
.details_containers_pgmbusiness .Partner_para_four_spans {
  width: 29px;
  height: 29px;
  background: #9ca8c0;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.details_containers_pgmbusiness .Partner_para_four_paragraph {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0rem;
}
.details_containers_pgmbusiness .Partner_para_fours_child {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.details_containers_pgmbusiness .Partner_para_four {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
  width: 98%;
  background: #eff6ff;
  align-items: center;
  text-align: center;
  padding: 0.8rem 0rem;
}
.details_containers_pgmbusiness .Partner_para_fours {
  display: flex;
  justify-content: space-between;
  width: 65%;
  align-items: center;
  text-align: center;
  padding: 0rem 0.4rem;
  gap: 1rem;
  flex-wrap: wrap;
}
.details_containers_pgmbusiness p {
  background: none;
}
.details_containers_pgmbusiness .Busiinesspara_first {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
  margin: 1rem;
}
.details_containers_pgmbusiness .Businesspara_seconds {
  display: flex;
  gap: 0.4rem;
  margin: 1rem;
}
.details_containers_pgmbusiness .selected {
  width: auto;
  height: 40px;
  background: #0c3688;
  border-radius: 6px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  border: none;
}
.details_containers_pgmbusiness .Businesspara_seconds_first {
  width: 185px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #bcc6d7;
  border-radius: 6px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #9ca8c0;
}
.details_containers_pgmbusiness .loginthirdpara {
  display: flex;
}
.details_containers_pgmbusiness .busiess-partners-veryfications-documents {
  display: block;
}
.details_containers_pgmbusiness #message {
  text-align: left;
  margin-left: 15px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: red;
  max-width: 250px;
}
.details_containers_pgmbusiness .activeAddnew {
  width: 15%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0C3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #ffffff;
}
.details_containers_pgmbusiness .store-image-del {
  position: absolute;
  margin: 0.1rem 6rem;
}
.details_containers_pgmbusiness .cursor-pointer {
  cursor: pointer;
}
.details_containers_pgmbusiness .AcceptPrivacyLink {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  color: #32363F;
  cursor: pointer;
  display: flex;
  gap: 0.2rem;
}
.details_containers_pgmbusiness .PrivacyPolicyText {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  color: #0C3688;
  text-decoration: underline;
  cursor: pointer;
}
.details_containers_pgmbusiness .disable_business_paraseven {
  display: none;
}
.details_containers_pgmbusiness .select-wrapper {
  position: relative;
  display: block;
}
.details_containers_pgmbusiness .input-wrappers {
  width: 32.5%;
}
.details_containers_pgmbusiness select {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 92%;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmbusiness label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2.5em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.details_containers_pgmbusiness .inputwrappers_business_partners {
  width: 30% !important;
  margin: 0rem 1rem !important;
}
.details_containers_pgmbusiness .plusicons {
  background-repeat: no-repeat;
  background-size: auto;
  width: 3rem;
  height: 3rem;
  margin: 2.8rem 2.8rem;
}
.details_containers_pgmbusiness .business-contact-pages-input {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
  padding: 1rem 0.6rem;
}
.details_containers_pgmbusiness .business-contact-pages-input-label {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
  padding: 1rem 0.6rem;
}
.details_containers_pgmbusiness input {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.details_containers_pgmbusiness .photosStore {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
  margin: 1rem;
}
.details_containers_pgmbusiness .facadetext {
  margin: 1rem;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #52443b;
}
.details_containers_pgmbusiness .pgm_details_eight_paras {
  display: flex;
  gap: 1.5rem;
  margin: 2rem 1rem;
}
.details_containers_pgmbusiness .veryfication_img > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #0c3688;
  display: flex;
  gap: 1rem;
}
.details_containers_pgmbusiness .veryfication_img > img {
  margin: -0.6rem 0.2rem;
}
.details_containers_pgmbusiness .veryfication_img-plus {
  border: 1px solid #AEB4C1;
  width: 7.8rem;
  height: 7.8rem;
  margin: 0rem 0.2rem;
}
.details_containers_pgmbusiness .veryfication_img {
  position: relative;
  display: flex;
}
.details_containers_pgmbusiness .stores-image {
  margin-left: 0.375rem;
}
.details_containers_pgmbusiness .business_parasix {
  display: flex;
  justify-content: space-between;
  width: 96%;
  border-bottom: 1px solid #bcc6d7;
  margin: 1rem;
  padding: 0.6rem;
}
.details_containers_pgmbusiness .business_parasixsspantext {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
}
.details_containers_pgmbusiness .input_checkbox {
  width: 18px;
  height: 18px;
}
.details_containers_pgmbusiness .business_paraseven {
  display: flex;
  width: 96%;
  margin: 1rem;
}
.details_containers_pgmbusiness .eleven_para_partners {
  display: flex;
  margin: 0rem 0rem;
}
.details_containers_pgmbusiness .next_buttons {
  background: #0c3688;
  box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);
  border-radius: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #ffffff;
  border: none;
  width: 160px;
  height: 40px;
  border: none;
  margin: 1.5rem 1rem;
}
.details_containers_pgmbusiness .text_count_business_name {
  position: absolute;
  left: 87.5%;
  z-index: 4;
  top: 63%;
  font-size: 13px;
}
.details_containers_pgmbusiness .text_count_complete_address {
  position: absolute;
  left: 86.5%;
  top: 56%;
}
.details_containers_pgmbusiness .text_count_name_of_business_organization {
  left: 19.8rem;
  position: absolute;
  top: 2.6rem;
  float: right;
}
.details_containers_pgmbusiness .text-count-name-of-business-record {
  position: absolute;
  top: 2.6rem;
  right: -9.4rem;
  float: right;
}
.details_containers_pgmbusiness .next_buttons:hover, .details_containers_pgmbusiness .next_buttons:disabled {
  background: #34518b;
  box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);
  border-radius: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #f8f4f4;
  border: none;
  width: 160px;
  height: 40px;
  border: none;
  margin: 1.5rem 1rem;
}
.details_containers_pgmbusiness .inputwrappers {
  width: 60%;
}
.details_containers_pgmbusiness .inputsbusinessrecords {
  width: 40%;
}
.details_containers_pgmbusiness .business-partners-span-text {
  display: flex;
  justify-content: end;
  margin: 0rem 2rem;
  position: relative;
  top: -3rem;
  z-index: 4;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: gray;
}
.details_containers_pgmbusiness .inputsbusinessrecords-commercial {
  width: 30%;
  margin: 0rem 1rem;
}
.details_containers_pgmbusiness .business_paraseven > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #32363f;
  margin: 0.5rem 0rem;
}
.details_containers_pgmbusiness .dash {
  border: 1px dashed #A3AEC4;
}
.details_containers_pgmbusiness .veryficationdoc > img {
  width: 96%;
  margin: 1rem;
}
.details_containers_pgmbusiness .verification-container {
  text-align: center;
  display: flex;
}
.details_containers_pgmbusiness .verification-line {
  width: 100%;
  margin: 10px 0;
  border-top: 1px solid #BCC6D7;
}
.details_containers_pgmbusiness .veryficationdoc {
  width: 98%;
  margin: 1rem;
}
.details_containers_pgmbusiness .verification-text {
  background-color: #fff;
  padding: 0 10px;
  color: #52443B;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1000000015px;
  text-align: center;
  white-space: nowrap;
}
.details_containers_pgmbusiness .crossicons {
  position: absolute;
  float: right;
  margin: 0rem 7rem !important;
}
.details_containers_pgmbusiness .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6vh !important;
}
.details_containers_pgmbusiness .loader-container .loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}
.details_containers_pgmbusiness .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4vh !important;
}
.details_containers_pgmbusiness .loader-container .loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 2s linear infinite;
}
.details_containers_pgmbusiness .tvs-training-ques {
  width: 96%;
  margin: 1rem;
}
.details_containers_pgmbusiness .Seven_para {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin: 0.2rem 0rem;
}
.details_containers_pgmbusiness .Seven_para > input {
  width: 13px;
  height: 13px;
}
.details_containers_pgmbusiness .Seven_para > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
}
.details_containers_pgmbusiness .Seven_para_span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #10132e;
}
.details_containers_pgmbusiness .workshoptext {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #0c3688;
}
.details_containers_pgmbusiness .suggestion-address {
  position: relative;
  z-index: 222;
  background: #E5F0FF;
  height: 5rem;
  width: 90%;
  overflow-y: scroll;
  margin: -0.7rem 0.8rem;
  padding: 3px;
  border-radius: 0rem 0rem 0.5rem 0.5rem;
}

@media screen and (max-width: 480px) {
  .details_containers_pgmbusiness .businessContainers {
    width: 100%;
    display: flex;
    overflow: hidden;
    height: 100vh;
    flex-direction: column;
  }
  .details_containers_pgmbusiness .businessContainerleft {
    width: 100%;
  }
  .details_containers_pgmbusiness .businessConntainersright {
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 50vh;
  }
  .details_containers_pgmbusiness .pgmlist_buttons {
    display: flex;
    width: 95%;
    flex-direction: column;
    margin: 1rem;
    gap: 1rem;
    border-bottom: 1px solid #c1c6d0;
  }
  .details_containers_pgmbusiness .activeAddnew {
    width: auto;
    height: 40px;
    left: 299px;
    top: 122px;
    background: #0C3688;
    border-radius: 8px 8px 0px 0px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    border: none;
    color: #ffffff;
  }
  .details_containers_pgmbusiness .business_paraseven {
    display: flex;
    width: 96%;
    margin: 2rem 1rem;
  }
  .details_containers_pgmbusiness .business_paraseven {
    display: flex;
    width: 96%;
    margin: 2rem 1rem;
  }
}
@media screen and (max-width: 768px) {
  .details_containers_pgmbusiness label {
    font-size: 10px !important;
  }
  .details_containers_pgmbusiness .businessContainers {
    flex-direction: column;
  }
  .details_containers_pgmbusiness .businessContainerleft {
    width: 100% !important;
  }
  .details_containers_pgmbusiness .businessConntainersright {
    width: 100% !important;
    height: 50vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/BusinessPartners/business.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AACA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AACF;AAEA;EACE,6BAAA;EACE,mBAAA;EACA,oBAAA;AAAJ;AAEA;EACE,kBAAA;EACD,UAAA;EACC,UAAA;EACA,SAAA;AAAF;AAEA;EACE,eAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AATJ;AACI;EACE,UAAA;AACN;AAEI;EACE,uBAAA;AAAN;AAKE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AAHJ;AAME;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAME;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAJJ;AAME;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AALJ;AAOE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AANJ;AASE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AAPJ;AASE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AARJ;AAWE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;AATJ;AAWE;EACE,gBAAA;AATJ;AAWE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AATJ;AAWE;EACE,aAAA;EACA,WAAA;EACA,YAAA;AATJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AATJ;AAWE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AATJ;AAWE;EACE,aAAA;AATJ;AAWE;EACE,cAAA;AATJ;AAWE;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AATJ;AAWE;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AATJ;AAWE;EACE,kBAAA;EACA,mBAAA;AATJ;AAWA;EACE,eAAA;AATF;AAWA;EACE,mBAAA;EACF,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AATA;AAWA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AATA;AAWA;EACE,aAAA;AATF;AAWE;EACE,kBAAA;EACA,cAAA;AATJ;AAYE;EACE,YAAA;AAVJ;AAaE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAXJ;AAaE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAXJ;AAaE;EACE,qBAAA;EACA,4BAAA;AAXJ;AAaA;EAEE,4BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAZF;AAcE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAZJ;AAcE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAZJ;AAcE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAZJ;AAcE;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAZJ;AAcE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAZJ;AAcE;EACE,sBAAA;AAZJ;AAcE;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAZJ;AAcE;EACE,kBAAA;EACA,aAAA;AAZJ;AAcE;EACE,qBAAA;AAZJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAZJ;AAcE;EACE,WAAA;EACA,YAAA;AAZJ;AAcE;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAZJ;AAcE;EACE,aAAA;EACA,iBAAA;AAZJ;AAcE;EACE,mBAAA;EACA,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAZJ;AAcE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAZJ;AAcA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAZF;AAcA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAZF;AAcA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAZF;AAcE;EACE,mBAAA;EACA,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAZJ;AAcE;EACE,UAAA;AAZJ;AAcE;EACE,UAAA;AAZJ;AAcE;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAZJ;AAcE;EACE,UAAA;EACA,iBAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAZJ;AAcE;EACE,0BAAA;AAZJ;AAcE;EACE,UAAA;EACA,YAAA;AAZJ;AAcE;EACE,kBAAA;EACA,aAAA;AAZJ;AAeE;EACE,WAAA;EACA,cAAA;EACA,6BAAA;AAbJ;AAgBE;EACE,UAAA;EACA,YAAA;AAdJ;AAiBE;EACE,sBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAfJ;AAiBE;EACE,kBAAA;EACA,YAAA;EACA,4BAAA;AAfJ;AAkBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAhBJ;AAiBI;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAfN;AAkBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAhBJ;AAiBI;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAfN;AAkBA;EACE,UAAA;EACA,YAAA;AAhBF;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAhBJ;AAkBE;EACE,WAAA;EACA,YAAA;AAhBJ;AAkBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAkBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAkBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAkBE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,sCAAA;AAhBJ;;AAoBA;EAEE;IACE,WAAA;IACA,aAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;EAlBF;EAoBF;IACE,WAAA;EAlBA;EAoBF;IACE,WAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;EAlBA;EAoBF;IACE,aAAA;IACA,UAAA;IACA,sBAAA;IACA,YAAA;IACA,SAAA;IACA,gCAAA;EAlBA;EAoBF;IACE,WAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,mBAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;EAlBA;EAoBF;IACE,aAAA;IACA,UAAA;IACA,iBAAA;EAlBA;EAmBD;IACC,aAAA;IACA,UAAA;IACA,iBAAA;EAjBA;AACF;AAqBA;EACE;IACE,0BAAA;EAnBF;EAsBA;IACE,sBAAA;EApBF;EAsBA;IACE,sBAAA;EApBF;EAsBA;IACE,sBAAA;IACA,uBAAA;EApBF;AACF","sourcesContent":[".details_containers_pgmbusiness{\n  overflow: hidden;\n  height: 100vh;\n\n.businessContainers {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n  height: 100vh;\n  \n}\n.loader-location{\n  position: absolute !important;\n    top: 28% !important;\n    left: 80% !important;\n}\n.busines_partners_crossicons{\n  position: absolute;\n z-index: 4;\n  left: 7rem;\n  top: 1rem;\n}\n.cursor-pointer{\n  cursor: pointer;\n}\n  .businessContainerleft {\n    width: 22%;\n  }\n  .businessConntainersright {\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 66px);\n\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n\n    scrollbar-width: none;\n  }\n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n  .header_border > img {\n    margin: 0.9rem 1rem;\n  }\n  .pgmlist_buttons {\n    display: flex;\n    width: 98%;\n    margin: 1rem;\n    gap: 1rem;\n    border-bottom: 1px solid #c1c6d0;\n  }\n\n  .Pgmlist_pending {\n    width: 15%;\n    height: 40px;\n    left: 299px;\n    top: 122px;\n    background: #0c3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n    color: #ffffff;\n  }\n  .pgmlist_Approved {\n    width: 15%;\n    height: 40px;\n    background: #e5f0ff;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7c87a1;\n    border: none;\n  }\n  .pgmlist_Add {\n    width: 15%;\n    height: 40px;\n    background: #e5f0ff;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7c87a1;\n    border: none;\n  }\n\n  .Partner_para_four_span {\n    width: 29px;\n    height: 29px;\n    background: #1445a4;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    border-radius: 50%;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  .Partner_para_four_paragraphs {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #9ca8c0;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 0rem;\n  }\n\n  .Partner_para_four_spans {\n    width: 29px;\n    height: 29px;\n    background: #9ca8c0;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    border-radius: 50%;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n\n  .Partner_para_four_paragraph {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 0rem;\n  }\n  .Partner_para_fours_child {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .Partner_para_four {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem;\n    width: 98%;\n    background: #eff6ff;\n    align-items: center;\n    text-align: center;\n    padding: 0.8rem 0rem;\n  }\n\n  .Partner_para_fours {\n    display: flex;\n    justify-content: space-between;\n    width: 65%;\n    align-items: center;\n    text-align: center;\n    padding: 0rem 0.4rem;\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n  p {\n    background: none;\n  }\n  .Busiinesspara_first {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n    margin: 1rem;\n  }\n  .Businesspara_seconds {\n    display: flex;\n    gap: 0.4rem;\n    margin: 1rem;\n  }\n  .selected {\n    width: auto;\n    height: 40px;\n    background: #0c3688;\n    border-radius: 6px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n    border: none;\n  }\n  .Businesspara_seconds_first {\n    width: 185px;\n    height: 40px;\n    background: #ffffff;\n    border: 1px solid #bcc6d7;\n    border-radius: 6px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #9ca8c0;\n  }\n  .loginthirdpara {\n    display: flex;\n  }\n  .busiess-partners-veryfications-documents{\n    display: block;\n  }\n  #message{\n    text-align: left;\n    margin-left: 15px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: red;\n    max-width: 250px;\n   }\n  .activeAddnew{\n    width: 15%;\n    height: 40px;\n    left: 299px;\n    top: 122px;\n    background: #0C3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n    color: #ffffff;\n  }\n  .store-image-del{\n    position: absolute;\n    margin: 0.1rem 6rem\n  }\n.cursor-pointer{\n  cursor: pointer;\n}\n.AcceptPrivacyLink{\n  font-family: Nunito;\nfont-size: 14px;\nfont-weight: 700;\ncolor: #32363F;\ncursor: pointer;\ndisplay: flex;\ngap: 0.2rem;\n}\n.PrivacyPolicyText{\nfont-family: Nunito;\nfont-size: 14px;\nfont-weight: 700;\ncolor:#0C3688;\ntext-decoration: underline;\ncursor: pointer;\n}\n.disable_business_paraseven{\n  display: none;\n}\n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n\n  .input-wrappers {\n    width: 32.5%;\n  }\n\n  select {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 92%;\n    height: 3.4rem;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n  label {\n    position: absolute;\n    top: 0.2ex;\n    z-index: 1;\n    left: 2.5em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n  .inputwrappers_business_partners {\n    width: 30% !important;\n    margin: 0rem 1rem !important;\n}\n.plusicons{\n  // background-image: url(\"../../../public/Img/Plusbusiness.svg\");\n  background-repeat: no-repeat;\n  background-size: auto;\n  width: 3rem;\n  height: 3rem;\n  margin: 2.8rem 2.8rem;\n}\n  .business-contact-pages-input {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 3.4rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n    padding: 1rem 0.6rem;\n  }\n  .business-contact-pages-input-label {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 3.4rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n    padding: 1rem 0.6rem;\n  }\n  input {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 3.4rem;\n    margin: 10px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0rem 1rem;\n    color: #10132e;\n    cursor: pointer;\n  }\n  .photosStore {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n    margin: 1rem;\n  }\n  .facadetext {\n    margin: 1rem;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #52443b;\n  }\n  .pgm_details_eight_paras {\n    display: flex;\n    gap: 1.5rem;\n    margin: 2rem 1rem;\n  }\n  .veryfication_img > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #0c3688;\n    display: flex;\n    gap: 1rem;\n  }\n  .veryfication_img > img {\n    margin: -0.6rem 0.2rem;\n  }\n  .veryfication_img-plus{\n    border: 1px solid #AEB4C1;\n    width: 7.8rem;\n    height: 7.8rem;\n    margin: 0rem 0.2rem;\n  }\n  .veryfication_img{\n    position: relative;\n    display: flex;\n  }\n  .stores-image{\n    margin-left: 0.375rem;\n  }\n  .business_parasix {\n    display: flex;\n    justify-content: space-between;\n    width: 96%;\n    border-bottom: 1px solid #bcc6d7;\n    margin: 1rem;\n    padding: 0.6rem;\n  }\n  .business_parasixsspantext {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n  }\n  .input_checkbox {\n    width: 18px;\n    height: 18px;\n  }\n  .business_paraseven {\n    display: flex;\n    width: 96%;\n    margin: 1rem;\n  }\n  .eleven_para_partners {\n    display: flex;\n    margin: 0rem 0rem;\n  }\n  .next_buttons {\n    background: #0c3688;\n    box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);\n    border-radius: 8px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    color: #ffffff;\n    border: none;\n    width: 160px;\n    height: 40px;\n    border: none;\n    margin: 1.5rem 1rem;\n  }\n  .text_count_business_name{\n    position: absolute;\n    left: 87.5%;\n    z-index: 4;\n    top: 63%;\n    font-size: 13px;\n}\n.text_count_complete_address{\n  position: absolute;\n  left: 86.5%;\n  top: 56%;\n}\n.text_count_name_of_business_organization {\n  left: 19.8rem;\n  position: absolute;\n  top: 2.6rem;\n  float: right;\n}\n.text-count-name-of-business-record {\n  position: absolute;\n  top: 2.6rem;\n  right: -9.4rem;\n  float: right;\n}\n  .next_buttons:hover,.next_buttons:disabled {\n    background: #34518b;\n    box-shadow: 0px 12px 20px rgba(42, 59, 137, 0.3);\n    border-radius: 8px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    color: #f8f4f4;\n    border: none;\n    width: 160px;\n    height: 40px;\n    border: none;\n    margin: 1.5rem 1rem;\n  }\n  .inputwrappers {\n    width: 60%;\n  }\n  .inputsbusinessrecords {\n    width: 40%;\n  }\n  .business-partners-span-text{\n    display: flex;\n    justify-content: end;\n    margin: 0rem 2rem;\n    position: relative;\n    top: -3rem;\n    z-index: 4;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: gray;\n  }\n  .inputsbusinessrecords-commercial {\n    width: 30%;\n    margin: 0rem 1rem;\n  }\n  .business_paraseven > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #32363f;\n    margin: 0.5rem 0rem;\n  }\n  .dash{\n    border: 1px  dashed #A3AEC4;\n  }\n  .veryficationdoc >img{\n    width: 96%;\n    margin: 1rem;\n  }\n  .verification-container {\n    text-align: center;\n    display: flex;\n  }\n  \n  .verification-line {\n    width: 100%;\n    margin: 10px 0;\n    border-top: 1px solid #BCC6D7;\n  }\n\n  .veryficationdoc{\n    width: 98%;\n    margin: 1rem;\n  }\n  \n  .verification-text {\n    background-color: #fff;\n    padding: 0 10px;\n    color: #52443B;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.10000000149011612px;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .crossicons{\n    position: absolute;\n    float: right;\n    margin: 0rem 7rem !important;\n  }\n  \n  .loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 6vh !important;\n    .loader {\n      border: 3px solid #f3f3f3;\n      border-top: 3px solid #3498db;\n      border-radius: 50%;\n      width: 35px;\n      height: 35px;\n      animation: spin 2s linear infinite;\n  }\n  }\n  .loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 4vh !important;\n    .loader {\n      border: 3px solid #f3f3f3;\n      border-top: 3px solid #3498db;\n      border-radius: 50%;\n      width: 25px;\n      height: 25px;\n      animation: spin 2s linear infinite;\n  }\n  }\n.tvs-training-ques{\n  width: 96%;\n  margin: 1rem;\n}\n  .Seven_para {\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n    margin: 0.2rem 0rem;\n  }\n  .Seven_para > input {\n    width: 13px;\n    height: 13px;\n  }\n  .Seven_para > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n  }\n  .Seven_para_span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #10132e;\n  }\n  .workshoptext {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    color: #0c3688;\n  }\n  .suggestion-address{\n    position: relative;\n    z-index: 222;\n    background: #E5F0FF;\n    height: 5rem;\n    width: 90%;\n    overflow-y: scroll;\n    margin: -0.7rem 0.8rem;\n    padding: 3px;\n    border-radius: 0rem 0rem 0.5rem 0.5rem;\n  }\n\n}\n@media screen and (max-width:480px) {\n\n  .details_containers_pgmbusiness .businessContainers {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n    height: 100vh;\n    flex-direction: column;\n}\n.details_containers_pgmbusiness .businessContainerleft {\n  width: 100%;\n}\n.details_containers_pgmbusiness .businessConntainersright {\n  width: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 50vh;\n}\n.details_containers_pgmbusiness .pgmlist_buttons {\n  display: flex;\n  width: 95%;\n  flex-direction: column;\n  margin: 1rem;\n  gap: 1rem;\n  border-bottom: 1px solid #c1c6d0;\n}\n.details_containers_pgmbusiness .activeAddnew {\n  width: auto;\n  height: 40px;\n  left: 299px;\n  top: 122px;\n  background: #0C3688;\n  border-radius: 8px 8px 0px 0px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  border: none;\n  color: #ffffff;\n}\n.details_containers_pgmbusiness .business_paraseven {\n  display: flex;\n  width: 96%;\n  margin: 2rem 1rem;\n}.details_containers_pgmbusiness .business_paraseven {\n  display: flex;\n  width: 96%;\n  margin: 2rem 1rem;\n}\n\n}\n\n@media screen and (max-width:768px) {\n  .details_containers_pgmbusiness label{\n    font-size: 10px !important;\n  }\n\n  .details_containers_pgmbusiness .businessContainers{\n    flex-direction: column;\n  }\n  .details_containers_pgmbusiness .businessContainerleft{\n    width: 100% !important;\n  }\n  .details_containers_pgmbusiness .businessConntainersright{\n    width: 100% !important;\n    height: 50vh !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
